import React from 'react';
import { Check, X } from 'lucide-react';
export function AudienceSection() {
  return <section className="py-12 md:py-16 bg-[#0f1623]" data-id="element-1">
      <div className="container mx-auto px-4" data-id="element-2">
        <div className="grid md:grid-cols-2 gap-12 max-w-5xl mx-auto" data-id="element-3">
          {/* Who this is for */}
          <div className="bg-[#0a0e1a] border border-[#00d4aa]/30 rounded-2xl p-8 shadow-[0_0_30px_rgba(0,212,170,0.05)]" data-id="element-4">
            <h3 className="text-2xl font-bold text-white mb-6 flex items-center gap-3" data-id="element-5">
              <span className="bg-[#00d4aa] text-black rounded-full p-1" data-id="element-6">
                <Check className="h-5 w-5" data-id="element-7" />
              </span>
              ¿Para quién es esto?
            </h3>
            <ul className="space-y-4" data-id="element-8">
              {['Padres con hijos de 9 a 14 años que aman los videojuegos.', 'Familias que quieren reducir los conflictos por el uso de tecnología.', 'Padres que no saben programar pero quieren que sus hijos tengan éxito.', 'Personas que buscan una actividad productiva para realizar en conjunto.'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-300" data-id="element-9">
                  <Check className="h-5 w-5 text-[#00d4aa] flex-shrink-0 mt-0.5" data-id="element-10" />
                  <span data-id="element-11">{item}</span>
                </li>)}
            </ul>
          </div>

          {/* Who this is NOT for */}
          <div className="bg-[#0a0e1a] border border-gray-800 rounded-2xl p-8 opacity-80" data-id="element-12">
            <h3 className="text-2xl font-bold text-gray-200 mb-6 flex items-center gap-3" data-id="element-13">
              <span className="bg-gray-700 text-gray-300 rounded-full p-1" data-id="element-14">
                <X className="h-5 w-5" data-id="element-15" />
              </span>
              ¿Para quién NO es?
            </h3>
            <ul className="space-y-4" data-id="element-16">
              {['Padres que buscan un curso académico de ciencias de la computación pura.', 'Niños menores de 7 años que aún no tienen comprensión lectora básica.', 'Familias que no tienen acceso a una computadora o laptop.'].map((item, idx) => <li key={idx} className="flex items-start gap-3 text-gray-400" data-id="element-17">
                  <X className="h-5 w-5 text-gray-500 flex-shrink-0 mt-0.5" data-id="element-18" />
                  <span data-id="element-19">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>
      </div>
    </section>;
}